import React, { useState, useEffect } from "react";
import * as Url from "./urls";
import Axios from "axios";
export const getAuditTrailList = (request = {}, headers = {}, params = {}) => {
  return Axios.post(Url.getAuditTrailList, request, {
    headers: headers,
    params: params,
  });
};
export const getReferrerCodeList = (
  request = {},
  headers = {},
  params = {}
) => {
  return Axios.post(Url.getReferrerCodeList, request, {
    headers: headers,
    params: params,
  });
};
export const getCreateReferrerCode = (
  request = {},
  headers = {},
  params = {}
) => {
  return Axios.post(Url.getCreateReferrerCode, request, {
    headers: headers,
    params: params,
  });
};
export const getDeleteList = (id) => {
  return Axios.delete(Url.getDeleteList + id);
};
export const getDeleteUser = (username) => {
  return Axios.delete(Url.getDeleteUser + username);
};
export const getDeleteBlocklist = (id) => {
  return Axios.delete(Url.getDeleteBlocklist + id);
};
export const getPasswordReset = (id) => {
  return Axios.post(Url.passwordRestUser + id);
};
export const reassignRole = (
  username,
  request = {},
  headers = {},
  params = {}
) => {
  return Axios.post(Url.reassignRoleurl + username, request, {
    headers: headers,
    params: params,
  });
};
export const role = (request = {}, headers = {}, params = {}) => {
  return Axios.get(Url.role, request, {
    headers: headers,
    params: params,
  });
};

export const getBlockList = (request = {}, headers = {}, params = {}) => {
  return Axios.post(Url.getBlockList, request, {
    headers: headers,
    params: params,
  });
};
export const searchBlocklist = (request = {}, headers = {}, params = {}) => {
  return Axios.post(Url.searchBlocklist, request, {
    headers: headers,
    params: params,
  });
};
export const saveBlocklist = (request = {}, headers = {}, params = {}) => {
  return Axios.post(Url.saveBlocklist, request, {
    headers: headers,
    params: params,
  });
};
export const getManageUserList = (request = {}, headers = {}, params = {}) => {
  return Axios.post(Url.getManageUserList, request, {
    headers: headers,
    params: params,
  });
};

export const getManageRegistrationList = (
  request = {},
  headers = {},
  params = {}
) => {
  return Axios.post(Url.getRegistrationList, request, {
    headers: headers,
    params: params,
  });
};
export const getManageUpdatedList = (
  request = {},
  headers = {},
  params = {}
) => {
  return Axios.post(Url.getUpdatedList, request, {
    headers: headers,
    params: params,
  });
};
export const getManageRejectedList = (
  request = {},
  headers = {},
  params = {}
) => {
  return Axios.post(Url.getRejectedList, request, {
    headers: headers,
    params: params,
  });
};
export const RegistrationDetails = (id) => {
  return Axios.get(Url.getVerificationList + id);
};

export const getUpdates = (setUpdations, setUpdatesStatus) => {
  let updates = [];

  const body = JSON.stringify({
    page: 1,
    size: 10,
  });

  fetch(Url.updates, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: body,
  }).then(function (response) {
    if (response.status == "200") {
      // flag=true;
      return response.json();
    } else {
    }
  });
};

export const getManageRejection = (
  setDataLoading,
  searchBy,
  searchByValue,
  fromDate,
  toDate,
  setRejected
) => {};
